export default __webpack_public_path__ + "media/60250ad1a8f4e1b17211a2728bc4b09287e60cc14c557f325a581d7a1ae03bb1.svg";